import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { BellIcon } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

type NotificationTriggerProps = ComponentPropsWithoutRef<'div'> & {
  compact: boolean;
  hasUnread: boolean;
  unreadCount: number;
  buttonLabel: string;
};

export const NotificationTrigger = forwardRef<HTMLDivElement, NotificationTriggerProps>(
  ({ compact, hasUnread, unreadCount, buttonLabel, className, ...rest }, ref) => (
    <div
      ref={ref}
      data-bell-trigger
      role="button"
      tabIndex={0}
      className={cn(
        'relative flex h-9 w-9 items-center justify-center rounded-full bg-black text-white shadow-lg ring-1 ring-slate-200 hover:bg-slate-700',
        'cursor-pointer',
        compact && 'mx-auto',
        className,
      )}
      aria-label={buttonLabel}
      title={buttonLabel}
      {...rest}
    >
      <BellIcon className="h-5 w-5" strokeWidth={1.7} />

      {hasUnread && (
        <span className="absolute -right-1 -top-1 inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1.5 text-[11px] font-semibold text-white">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  ),
);

NotificationTrigger.displayName = 'NotificationTrigger';
